import axiosInstance from './AxiosInstance';

const API_URL = 'boxfolderofemps';

export const getBoxFolderOfEmps = async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching Box Folder of Emps', error);
        return {}
    }
};

export const getBoxFolderOfEmpById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching Box Folder of Emp with id ${id}`, error);
        return {}
    }
};

export const getBoxFolderOfEmpByEmail = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/viewByEmail/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching Box Folder of Emp with Email ${email}`, error);
        return {folderId: '0', isError: true };
    }
};

export const createBoxFolderOfEmp = async (folder) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, folder);
        return response.data;
    } catch (error) {
        console.error('Error creating Box Folder of Emp', error);
        return {}
    }
};

export const updateBoxFolderOfEmp = async (id, folder) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...folder });
        return response.data;
    } catch (error) {
        console.error(`Error updating Box Folder of Emp with id ${id}`, error);
        return {}
    }
};

export const deleteBoxFolderOfEmp = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting Box Folder of Emp with id ${id}`, error);
        return {}
    }
};

export const importExcel = async (data) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/import-excel`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        return response.data;
    } catch (error) {
        console.error('Error import-excel box folder', error);
        throw error;
    }
};
